import { accentHex, accentReadable } from "../demo-v2/accents.js";
import type { AccentId } from "../demo-v2/types.js";
import type { FlowCopy, WallCopy } from "./content.js";
import { PHOTOS, photoById } from "./photos.js";
import { InviteMock, Phone } from "./screens.js";
import { Wall } from "./wall.js";

const FEATURED = photoById("c16");
const RECENT = PHOTOS.filter((photo) => photo.id !== FEATURED.id)
  .slice(-7, -1)
  .reverse();

export interface BrandColors {
  readonly button: string;
  readonly line: string;
  readonly ring: string;
}

export function brandColors(id: AccentId): BrandColors {
  const hex = accentHex(id);
  const onDark = accentReadable(id) ? hex : "var(--on-photo-2)";
  return { button: hex, line: onDark, ring: onDark };
}

export interface BrandSceneProps {
  readonly name: string;
  readonly accent: AccentId;
  readonly flow: FlowCopy;
  readonly wall: WallCopy;
}

export function BrandScene({ name, accent, flow, wall }: BrandSceneProps) {
  const colors = brandColors(accent);
  return (
    <div class="scene is-studio">
      <div class="scene-tv">
        <Wall
          copy={wall}
          host={name}
          accent={colors.ring}
          count={17}
          featured={{ key: FEATURED.id, src: FEATURED.large, author: FEATURED.author }}
          recent={RECENT}
        />
      </div>
      <div class="scene-phone">
        <Phone>
          <div class="phone-page is-on">
            <InviteMock copy={flow} host={name} accent={colors.button} line={colors.line} />
          </div>
        </Phone>
      </div>
    </div>
  );
}
